var exports = {
  "E": "Text__IjKneD",
};

module.exports = exports;
